var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiketmeta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 29,
    viewBox: "0 0 50 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.77869 25.5123C3.75543 25.5123 3.6814 25.5123 3.62217 25.4361C3.56295 25.3598 3.5841 25.2918 3.59045 25.2691L10.0034 3.94108C10.088 3.66074 10.3059 3.55768 10.4286 3.52057C10.4772 3.50615 10.547 3.49172 10.6274 3.49172C10.7458 3.49172 10.8854 3.52264 11.0229 3.63189L22.9669 13.1529L45.5182 3.54943C45.8439 3.41133 46.085 3.55562 46.1992 3.6525C46.3135 3.75144 46.4911 3.96581 46.3896 4.29768L43.0647 15.3131H46.7978L49.8245 5.28297C50.292 3.73289 49.8097 2.10448 48.566 1.03468C47.3224 -0.0351241 45.6049 -0.296907 44.0841 0.350333L23.538 9.09838L13.2861 0.92749C12.1862 0.0535099 10.7205 -0.222699 9.3668 0.185433C8.01101 0.595627 6.96404 1.63245 6.5664 2.95785L0.155515 24.2859C-0.182902 25.4093 0.0370683 26.5904 0.756204 27.5262C1.47534 28.462 2.57731 29 3.77869 29H35.9093L36.9626 25.5103H3.77869V25.5123Z",
    fill: "#0A1E4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiketmeta);
export default __webpack_public_path__ + "static/media/tiketmeta.4bb5e56911e22c288d1b2579d36ef2d7.svg";
export { ForwardRef as ReactComponent };